import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export type UpCustomDataAttribute = {
  fCustomDataAttributeCountry: string[];
  fCustomDataAttributeDataType: string;
  fCustomDataAttributeLabel: string;
  fCustomDataAttributeName: string;
  fCustomDataCreatedTime: string;
  fCustomDataCreatedUserId: number;
  fCustomDataUpdatedTime: string;
  fCustomDataUpdatedUserId: number;
  fCustomDataAttributeDataSubtype?: string;
};

export type IndexedUpCustomDataAttribute = {
  [key: string]: UpCustomDataAttribute;
};
export const customDataAttributes =
  async (): Promise<IndexedUpCustomDataAttribute> => {
    return await fetchFromOldApi(
      `/json/customdata/entity/UNIT_POSITION/attribute`,
    ).then((r) =>
      r
        .json()
        .then((r: UpCustomDataAttribute[]) =>
          r.reduce(
            (acc, cur) => ({ ...acc, [cur.fCustomDataAttributeName]: cur }),
            {},
          ),
        ),
    );
  };
export const useGetUnitPositionCustomDataAttributes = (
  swrConfig?: SWRConfiguration,
): UseSWROutput<IndexedUpCustomDataAttribute> => {
  return useSWR(
    'useGetUnitPositionCustomDataAttributes',
    () => customDataAttributes(),
    swrConfig,
  );
};
